import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, getUserData } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthentication = async () => {
      await getUserData();
      setIsLoading(false);
    }

    checkAuthentication();
  }, [getUserData]);

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/register");
    }
  }, [isAuthenticated, navigate, isLoading]);

  if (isLoading || !isAuthenticated) {
    return null;
  }

  return children;
};

export default PrivateRoute;